import React from 'react';
import { compareDesc } from 'date-fns';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import _ from 'lodash';
import logger from '../../logger';

import EditCustomerModal from '../../components/Customers/EditCustomerModal';
import { SurveyContext } from '../../SurveyContext';
import { filterCustomers, updateSurveysWorkspace } from '../../utils/miscFunctions';
import FiltersDisplay from '../FiltersDisplay';
import TableDisplay from '../TableDisplay';
import VaultApiRequestService from '../../VaultApiRequestService';
import { isActiveTypes } from '../../utils/enums';

class AllCustomers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            createOpen: false,
            editOpen: false,
            searchTerm: '',
            statusFilter: isActiveTypes.ALL,
            customerToEdit: undefined,
            openSnackbar: false,
            snackbarMessage: '',
        };
    }

    updateState = (value, state) => {
        this.setState({
            [state]: value
        }, () => {
            // if search or filter changes, set page to 0
            if (state === 'searchTerm') {
                this.updateState(0, "page");
            }
        })
    }

    onCustomerClick = (data) => {
        this.props.history.push(`/campaigns/${data.id}`);
    }

    updateSurveys = async (isActive) => {
        const { customerToEdit } = this.state;
        const surveys  = _.flatten(customerToEdit.campaigns.map(campaign => campaign.surveys));
        const changeWorkspaceSuccess = await updateSurveysWorkspace({ isActive, surveys: surveys });
        if (!changeWorkspaceSuccess) {
            logger.exception(
                'Error changing surveys workspace in Typeform',
                '',
                { isActive, surveys }
            );
            this.setState({
                openSnackbar: true,
                snackbarMessage: 'Error changing surveys workspace in Typeform'
            });
        }
    }

    updateCustomerInVault = async (payload) => {
        try {
            const { customerToEdit } = this.state;
            const leanCustomer = _.pick(customerToEdit, ['level_0', 'is_active', 'name']);
            if (_.isEqual(_.omit(payload, 'lastUpdated'), leanCustomer)) {
                    this.setState({
                        editOpen: false,
                    });
            } else {
                let leanPayload = _.omitBy(payload, _.isUndefined);
                if (customerToEdit.is_active === leanPayload.is_active) {
                    leanPayload = _.omit(leanPayload, ['is_active']);
                }
                const response  = await VaultApiRequestService.editCustomer(
                    leanPayload,
                    customerToEdit.id
                );
                if (!response?.data) {
                    logger.exception(
                        'Error editing client in Vault',
                        _.get(response, 'message'),
                        { payload }
                    );
                    this.setState({
                        openSnackbar: true,
                        snackbarMessage: 'Error editing client in Vault'
                    });
                } else {
                    // Update typeform surveys workspace.
                    if(!_.isUndefined(_.get(leanPayload,'is_active'))) {
                        await this.updateSurveys(_.get(leanPayload,'is_active'));
                    }
                    await this.context.fetchAndUpdateCustomers();
                }
                this.setState({ editOpen: false });
            } 
        } catch (err) {
            logger.error(err, { action: 'Edit customer in Vault', payload });
            this.setState({
                openSnackbar: true,
                snackbarMessage: `Error editing client in Vault`
            });
            this.setState({ editOpen: false });
        }
    }

    createNewCustomerInVault = async (payload) => {
        try {
            const response  = await VaultApiRequestService.addNewCustomer(payload);
            if (!response?.data) {
                logger.exception(
                    'Error creating client in Vault',
                    _.get(response, 'message'),
                    { payload }
                );
                this.setState({
                    openSnackbar: true,
                    snackbarMessage: `Error creating customer to Vault, ${response.message}`
                });
            } else {
                await this.context.fetchAndUpdateCustomers();
            }
            this.setState({ createOpen: false });
        } catch (err) {
            logger.error(err, { action: 'Create customer in Vault', payload });
            this.setState({
                openSnackbar: true,
                snackbarMessage: 'Error editing customer to Vault',
            });
            this.setState({ createOpen: false });
        }
    };

    onEditCustomerClick = (customerId) => {
        const customer = this.context.customers.find(customer => customer.id === customerId);
        this.setState({
            customerToEdit: customer,
            editOpen: true,
        });
    }

    toggleEdit = () => {
        this.setState({ createOpen: !this.state.createOpen })
    }

    render() {
        const { 
            createOpen, editOpen, searchTerm, 
            statusFilter, customerToEdit,
            snackbarMessage, openSnackbar
        } = this.state;
        let filteredCustomers = this.context.customers.filter(filterCustomers(searchTerm));
        filteredCustomers = filteredCustomers.filter(customer => {
            if (statusFilter === isActiveTypes.ALL) {
                return true;
            }
            return customer.is_active === statusFilter;
        })
        filteredCustomers = filteredCustomers.sort((a, b) => compareDesc(
            a.dateCreated,
            b.dateCreated
        ));
        return (
            <div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <h2 style={{ textAlign: 'center', marginRight: 10 }}> Customers </h2>
                    <Button variant="outlined" color="primary" onClick={this.toggleEdit}> New Customer </Button>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                    <FiltersDisplay
                        setSearchTerm={v => this.setState({searchTerm: v})}
                        setStatusFilter={v => this.setState({statusFilter: v})}
                        searchTerm={searchTerm}
                    />
                    <div style={{ width: '95%' }}>
                    <TableDisplay 
                        data={filteredCustomers}
                        tableHeaders={["Name", "Campaigns", "Last Updated", "Active"]}
                        tableFields={["name", "campaigns.length", "lastUpdated", "is_active"]}
                        onRowClick={this.onCustomerClick}
                        onEditClick={this.onEditCustomerClick}
                    />
                    </div>
                </div>
                {createOpen && 
                    <EditCustomerModal
                        open={createOpen}
                        onClose={this.toggleEdit}
                        name={''}
                        level_0={''}
                        isActive={true}
                        saveClick={this.createNewCustomerInVault}
                        action="new"
                    />
                }
                {editOpen && 
                    <EditCustomerModal
                        open={editOpen}
                        onClose={() => {
                            this.setState({
                                customerToEdit: undefined,
                                editOpen: false,
                            });
                        }}
                        name={customerToEdit.name}
                        levelZero={customerToEdit.level_0}
                        isActive={customerToEdit.is_active}
                        saveClick={this.updateCustomerInVault}
                    />
                }
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={openSnackbar}
                    autoHideDuration={3000}
                    onClose={() => this.setState({ openSnackbar: false })}
                    message={snackbarMessage}
                    style={{ fontSize: 14 }}
                />
            </div>
        )
    }
}

AllCustomers.contextType = SurveyContext;

export default AllCustomers;
